import { Controller } from "@hotwired/stimulus";

const SECURITY_TAB = "security-settings";

export default class extends Controller {
  static targets = ["content", "footerDelete", "footerActions", "footerClose"];

  // Store a bound reference so the same function can be removed in disconnect().
  #onTabShown = (e) => this.#updateFooter(e.target?.getAttribute("aria-controls"));

  connect() {
    // Set modal height for all tabs when the modal is shown, to prevent height changes when switching tabs.
    this.element.closest(".modal").addEventListener("shown.bs.modal", () => this.#equalizeTabHeights(), { once: true });

    // Update footer buttons when switching tabs.
    this.element.addEventListener("shown.bs.tab", this.#onTabShown);
    // Set initial footer button visibility based on the active tab.
    this.#updateFooter(this.#activeTabId());
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.#onTabShown);
  }

  // private

  #equalizeTabHeights() {
    const panes = this.contentTarget.querySelectorAll(".tab-pane");
    const containerWidth = this.contentTarget.offsetWidth;
    let maxHeight = 0;

    panes.forEach((pane) => {
      const wasHidden = !pane.classList.contains("active");

      // Temporarily render hidden panes off-screen so scrollHeight is measurable.
      if (wasHidden) {
        pane.style.display = "block";
        pane.style.visibility = "hidden";
        pane.style.position = "absolute";
        pane.style.width = `${containerWidth}px`;
      }

      maxHeight = Math.max(maxHeight, pane.scrollHeight);

      if (wasHidden) {
        pane.style.display = "";
        pane.style.visibility = "";
        pane.style.position = "";
        pane.style.width = "";
      }
    });

    this.contentTarget.style.minHeight = `${maxHeight}px`;
  }

  #activeTabId() {
    return this.element.querySelector(".nav-link.active")?.getAttribute("aria-controls");
  }

  #updateFooter(tabId) {
    const isSecurity = tabId === SECURITY_TAB;
    if (this.hasFooterDeleteTarget) this.footerDeleteTarget.hidden = isSecurity;
    if (this.hasFooterActionsTarget) this.footerActionsTarget.hidden = isSecurity;
    if (this.hasFooterCloseTarget) this.footerCloseTarget.hidden = !isSecurity;
  }
}
